/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Provides all containers.
 */
import Playground from './playground';
import Despachos from './despachos';
import Users from './users';
import Aduanas from './aduanas';
import Conceptos from './conceptos';
import Login from './login';
import Status from './status';
import Proveedores from './proveedores';
import Clientes from './clientes';
import Reportes from './reportes';
import Home from './home';

export {
    Playground,
    Despachos,
    Users,
    Aduanas,
    Conceptos,
    Login,
    Status,
    Proveedores,
    Clientes,
    Reportes,
    Home
};



// WEBPACK FOOTER //
// ./containers/index.js